import { put, call, takeLatest } from 'redux-saga/effects'

import { WORKFLOW_STATUS_PARAM } from 'Constants'

import { getTags as getWorkFlowStatusesApi } from 'Service/Api'

import * as WorkFlowStatusesTypes from 'Redux/Types/WorkFlowStatusesTypes'
import * as WorkFlowStatusesActions from 'Redux/Actions/WorkFlowStatusesActions'

function* getWorkFlowStatuses() {
  try {
    const { data } = yield call(getWorkFlowStatusesApi, WORKFLOW_STATUS_PARAM)
    yield put(WorkFlowStatusesActions.getWorkFlowStatusesSucceeded(data))
  } catch (errors) {
    yield put(WorkFlowStatusesActions.getWorkFlowStatusesFailed(errors))
  }
}

export default function* WorkFlowStatusSaga() {
  yield takeLatest(WorkFlowStatusesTypes.GET_EXPENSE_WORKFLOW_STATUSES, getWorkFlowStatuses)
}
